import * as Icon from 'react-bootstrap-icons';
import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";
import {useStore} from "../../store/store";
import SimpleModal from "../Modal/SimpleModal";
import {getWeekNumber, changeKw} from '../../service/general';
import './Meldung.css';


export default function Meldungen(props) {
    const [showModal, setShowModal] = useState(false);
    const currDate = new Date();
    const Items = JSON.parse(localStorage.getItem('items'));
    const MeldungForm = useRef();
    const [globalState, dispatch] = useStore();
    const emptyItems = [];
    Items && Items.map((item) => {
        return emptyItems[item['No_']] = [];
    });
    const [kw, setKw] = useState(getWeekNumber(currDate));
    const [meldungen, setMeldungen] = useState([]);
    const [dataSeries, setDataSeries] = useState(changeKw(currDate.getFullYear(), kw));
    const [showTable, setShowTable] = useState('amounts');


    function formatDateHeadline(dateIndex: [], withPoint: boolean = true) {
        if (true === withPoint) {
            return dataSeries[dateIndex].getDate() + '.' + ('0' + (dataSeries[dateIndex].getMonth() + 1)).slice(-2) + '.' + dataSeries[dateIndex].getFullYear()
        } else {
            return '' + dataSeries[dateIndex].getFullYear() + ('0' + (dataSeries[dateIndex].getMonth() + 1)).slice(-2) + ('0' + dataSeries[dateIndex].getDate()).slice(-2);
        }
    }

    const fetchMeldungen = async () => {
        const header = "Authorization: Bearer " + localStorage.getItem("token");
        try {
            const response = await axios.get(
                APIBASE + 'api/meldung/' + getWeekNumber(dataSeries[0]) + '/' + dataSeries[0].getUTCFullYear(), {headers: header}
            );
            const data = await response.data;
            setMeldungen(data);
        } catch (err) {
            dispatch('IS_401_ERROR', true);
            dispatch('SET_AUTHTOKEN', null);
            console.log(err); // Todo: Errorhandling
        }
    };

    useEffect(() => {
        fetchMeldungen();
        document.getElementById('report') && document.getElementById('report').reset();
    }, [globalState.token, dataSeries]);


    function saveMeldung(event) {
        event.preventDefault();
        var formData = {amounts: [], salesNotes: [], general: []}
        let localDate = new Date(dataSeries[0].getTime() - dataSeries[0].getTimezoneOffset() * 60000);
        formData.general.push({kw: kw, startDate: dataSeries[0]});
        Items.map((item) => {
            formData.amounts.push({
                date: localDate,
                key: item.No_,
                checkedNew: event.target.elements[`newLine_${item.No_}`].checked,
                amount_0: event.target.elements[`value_${item.No_}_0`].value,
                amount_1: event.target.elements[`value_${item.No_}_1`].value,
                amount_2: event.target.elements[`value_${item.No_}_2`].value,
                amount_3: event.target.elements[`value_${item.No_}_3`].value,
                amount_4: event.target.elements[`value_${item.No_}_4`].value,
                amount_5: event.target.elements[`value_${item.No_}_5`].value,
                amount_6: event.target.elements[`value_${item.No_}_6`].value,
            });
            formData.salesNotes.push({
                akey: item.No_,
                hint: event.target.elements[`salesNote_${item.No_}`].value
            });

        });
        const header = "Authorization: Bearer " + localStorage.getItem("token");
        axios({
            method: 'post',
            url: APIBASE + 'api/saveMeldung',
            rejectUnauthorized: false,
            data: formData,
            headers: header
        }).then(result => {
            setShowModal(true);
            fetchMeldungen();
        })
            .catch(error => {
                console.log(error);
            });


    }

    function setNewDataSeries(year, kw) {
        let newWeek = Number(kw);
        if (newWeek == 0) {
            newWeek = 53;
            year--;
        }
        if (newWeek > 53) {
            newWeek = 1;
            year++
        }
        setKw(newWeek);
        setDataSeries(changeKw(year, newWeek));
    }

    return (<>{globalState.token && <>
            <SimpleModal show={showModal} onHide={() => setShowModal(false)} content={{
                title: 'Meldung gespeichert',
                body: 'Die Meldung für KW ' + kw + ' wurde gespeichert'
            }}/>
            <h1>Mengenmeldung</h1>
            <form id="report" onSubmit={saveMeldung} ref={MeldungForm}>
                <ul className="nav ">
                    <li className="nav-item">
                        <button
                            onClick={() => setNewDataSeries(dataSeries[0].getFullYear(), kw - 1)}
                            type="button" className="btn btn-secondary btn-sm">
                            <Icon.Calendar/> Zurück
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            onClick={() => setNewDataSeries(currDate.getFullYear(), getWeekNumber(currDate))}
                            type="button" className="btn btn-secondary btn-sm">
                            <Icon.Calendar/> Aktuell
                        </button>
                    </li>
                    <li className="nav-item ">
                        <button
                            onClick={() => setNewDataSeries(dataSeries[0].getFullYear(), kw + 1)}
                            type="button" className="btn btn-secondary btn-sm">
                            <Icon.Calendar/> Vor
                        </button>
                    </li>
                    <li className="nav-item">
                        <button type="submit" className="btn btn-secondary btn-sm">
                            <Icon.Save/> Speichern
                        </button>
                    </li>
                </ul>
                <ul className="nav">
                    <li className="nav-item">
                        <button className="btn btn-success btn-sm" onClick={() => setShowTable('amounts')}
                                type="button">Mengen
                        </button>
                    </li>
                    <li className="nav-item">
                        <button className="btn btn-success btn-sm" type="button"
                                onClick={() => setShowTable('distribution')}>Hinweis für den Vertrieb
                        </button>
                    </li>
                </ul>

                <table className="table" style={{display: (showTable === 'amounts' ? 'block' : 'none')}}>
                    <tbody>
                    <tr key={`head_${formatDateHeadline(0)}`}>
                        <td><b>Produkt</b><br/>KW: {kw}</td>
                        <td>neuer Satz</td>
                        <td><b>Sa</b><br/>{formatDateHeadline(0)}</td>
                        <td><b>So</b><br/>{formatDateHeadline(1)}</td>
                        <td><b>Mo</b><br/>{formatDateHeadline(2)}</td>
                        <td><b>Di</b><br/>{formatDateHeadline(3)}</td>
                        <td><b>Mi</b><br/>{formatDateHeadline(4)}</td>
                        <td><b>Do</b><br/>{formatDateHeadline(5)}</td>
                        <td><b>Fr</b><br/>{formatDateHeadline(6)}</td>
                    </tr>
                    {Items && Items.map((item) => {

                        return (<tr key={`data_${item.No_}`}>
                            <td>{item.description}</td>
                            <td><input className="form-check-input" type="checkbox" name={`newLine_${item.No_}`} defaultChecked={meldungen.newSet && meldungen.newSet[item.No_] && meldungen.newSet[item.No_][kw]}/>
                            </td>
                            <td><input disabled={dataSeries[0] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_0`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(0, false)]}/>
                            </td>
                            <td><input disabled={dataSeries[1] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_1`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(1, false)]}/>
                            </td>
                            <td><input disabled={dataSeries[2] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_2`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(2, false)]}/>
                            </td>
                            <td><input disabled={dataSeries[3] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_3`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(3, false)]}/>
                            </td>
                            <td><input disabled={dataSeries[4] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_4`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(4, false)]}/>
                            </td>
                            <td><input disabled={dataSeries[5] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_5`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(5, false)]}/>
                            </td>
                            <td><input disabled={dataSeries[6] < currDate} type="text" className="form-control"
                                       name={`value_${item.No_}_6`}
                                       defaultValue={meldungen.amounts && meldungen.amounts[item.No_] && meldungen.amounts[item.No_][formatDateHeadline(6, false)]}/>
                            </td>

                        </tr>)
                    })}

                    </tbody>
                </table>

                <table className="table" style={{display: (showTable === 'distribution' ? 'block' : 'none')}}>
                    <tbody>
                    <tr>
                        <td><b>Produkt</b><br/>KW: {kw}</td>
                        <td><b>Hinweis für den Vertrieb KW {kw}</b><br/>
                            von {formatDateHeadline(0)} bis {formatDateHeadline(6)}</td>
                    </tr>
                    {Items && Items.map((item) => {
                        let hintIdx = '' + kw + dataSeries[0].getUTCFullYear();
                        return (<tr key={`salesNote_${item.No_}`}>
                            <td>{item.description}</td>
                            <td><input disabled={dataSeries[0] < currDate} type="text"
                                       name={`salesNote_${item.No_}`}
                                       size="100"
                                       defaultValue={meldungen.hints && meldungen.hints[item.No_] && meldungen.hints[item.No_][hintIdx] && meldungen.hints[item.No_][hintIdx]}
                                       placeholder=" Hinweis an Vertrieb "/></td>
                        </tr>)
                    })}
                    </tbody>
                </table>
            </form>
        </>
        }
        </>
    )
}